<template>
  <div class="dashboard">
    <!-- BEGIN CONTENT BODY -->
    <!-- BEGIN PAGE HEADER-->
    <breadcrumbs :crumbs="[{name: `${participantSingularName} Directory`, link:'Participant Directory'}, `${participantSingularName} Dashboard`]"/>
    <!--END PAGE HEADER-->
    <div class="row">
      <div class="col-md-4 db-column" id="first-column">
        <widget :name="widgets.widgetsFirst" :type="'widgetsFirst'" draggable=".portlet" v-on:passWidgets="widgetsData"></widget>
      </div>
      <div class="col-md-4 db-column" id="second-column">
        <widget :name="widgets.widgetsSecond" :type="'widgetsSecond'" draggable=".portlet" v-on:passWidgets="widgetsData"></widget>
      </div>
      <div class="col-md-4 db-column" id="third-column">
        <widget :name="widgets.widgetsThird" :type="'widgetsThird'" draggable=".portlet" v-on:passWidgets="widgetsData"></widget>
      </div>
    </div>
    <!--END CONTENT BODY-->
  </div>
</template>

<script>
import { HTTP, ERROR, updateUserInfo } from '@/http-common';
import draggable from 'vuedraggable';
import Widget from '@/components/widgets/Widget.vue';
import Breadcrumbs from '@/components/Breadcrumbs'
import {mapActions, mapGetters} from 'vuex';
import participantDisplayName from '@/mixins/participantDisplayName';

export default {
  mixins: [
    participantDisplayName
  ],
  components: {
    draggable,
    Widget,
    Breadcrumbs
  },
  data () {
    let widgets = null;
    const user_account = JSON.parse(localStorage.getItem('user_account'));

    if (user_account.settings.widgets == null)  {
      widgets = {
        "widgetsFirst": [{
          "id": "1",
          "name": "ProfileParticipant"
        }, {
          "id": "4",
          "name": "ActivitiesAndServices"
        }],
        "widgetsSecond": [{
          "id": "3",
          "name": "Assingment"
        },{
          "id": "2",
          "name": "AssessmentAndOutcomes"
        }],
        "widgetsThird": [{
          "id": "5",
          "name": "CaseNotes"
        }],
      }
    } else {
      widgets = JSON.parse(user_account.settings.widgets)
    }
    return {
      widgets,
      portlet: '',
    }
  },
  beforeMount() {
    if(this.$route.params.id) {
      this.loadParticipant(this.$route.params.id);
    }
  },
  computed: {
    ...mapGetters({
      user: 'getParticipant',
    })
  },
  methods: {
    ...mapActions({
      loadParticipant:'loadParticipant',
      loadCaseManagers:'loadCaseManagers',
      removeParticipant: 'REMOVE_PARTICIPANT_ACTION',
    }),
    widgetsData(data) {
      Object.keys(this.widgets).forEach((obj) => {
        if(obj === data['0']) {
          this.widgets[obj] = data['1'];
        }
      });
      this.saveData();
    },
    saveData: _.debounce(
      function () {
        HTTP.post(`users/settings`, {name: 'widgets', value: JSON.stringify(this.widgets)})
          .then(response => {
            ERROR(response);
            if(response.data.status === 'success') {
              updateUserInfo('settings', {"widgets": JSON.stringify(this.widgets)});
            }
          })
          .catch(err => {
            console.log(err);
          })
      }),
  },
  watch: {
    '$route.params.id': function () {
      this.loadParticipant(this.$route.params.id);
    }
  }
}
</script>
<style scoped>
.flip-list-move {
  transition: transform 0.5s;
}
.db-column > div, .db-column > div > span {
  min-height: 50vh;
  display: block;
}
</style>



// WEBPACK FOOTER //
// ParticipantDashboard.vue?b0249b8a